import { createAsyncThunk } from "@reduxjs/toolkit"
import { ProjectProcess, ProjectProcessHeader } from "../projectProcess/ProjectProcessApiClient"
import { AppId, AppThunkAPIType } from "../../../app/appTypes"
import { getWithAuth, postWithAuth } from "../../../http"
import { CreateSystemDocumentTemplatePayload } from "../../system/api/systemTypes"
import { DocumentHeader } from "../../documents/documentsApi"
import { DocumentCreationModes, DocumentLanguages, DocumentTypes } from "../../documents/documentTypes"

export const loadSupplierDocumentationProcesses = createAsyncThunk<ProjectProcessHeader[], void, AppThunkAPIType>(
    "documentation-processes/supplier/load-documentation", async (_, { dispatch, rejectWithValue }) => {
        const result = await dispatch(getWithAuth({ url: "api/documentation-processes/supplier" }))
        const { payload } = result

        if (getWithAuth.fulfilled.match(result)) {
            return payload as ProjectProcessHeader[]
        } else {
            return rejectWithValue(payload ?? { kind: 'unknown' })
        }
    })


export const loadCustomDocumentationProcesses = createAsyncThunk<ProjectProcessHeader[], void, AppThunkAPIType>(
    "documentation-processes/custom/load", async (_, { dispatch, rejectWithValue }) => {
        const result = await dispatch(getWithAuth({ url: "api/documentation-processes/custom" }))
        const { payload } = result

        if (getWithAuth.fulfilled.match(result)) {
            return payload as ProjectProcessHeader[]
        } else {
            return rejectWithValue(payload ?? { kind: 'unknown' })
        }
    })


export interface CreateSupplierDocProcessPayload {
    no: string
    name: string
    ursRequestId: string | null
    reqisterNewDevice: boolean
    serialNo: string
    deviceName: string
}

export interface CreateCustomDocProcessPayload {
    no: string
    name: string
    structureId: string | null
}

export const createSupplierDocProcess = createAsyncThunk<ProjectProcessHeader, CreateSupplierDocProcessPayload, AppThunkAPIType>(
    "documentation-processes/supplier/createSupplierDocProcess",
    async (createProcessPayload: CreateSupplierDocProcessPayload, { rejectWithValue, dispatch }) => {
        const result = await dispatch(postWithAuth({
            url: "api/documentation-processes/supplier",
            payload: createProcessPayload,
        }))
        const { payload } = result

        if (postWithAuth.fulfilled.match(result)) {
            return payload as ProjectProcessHeader
        } else {
            return rejectWithValue(payload ?? { kind: 'unknown' })
        }
    }
)

export const generateSupplierDocuments = createAsyncThunk<ProjectProcess, { processId: AppId, specId: number, document: string }, AppThunkAPIType>(
    "documentation-processes/supplier/generateSupplierDocuments",
    async ({ processId, specId, document }, { dispatch, rejectWithValue }) => {
        const result = await dispatch(postWithAuth({
            url: `api/documentation-processes/supplier/generate/`,
            payload: {
                processId: processId,
                specId: specId,
                document: document
            },
        }))
        const { payload } = result
        if (postWithAuth.fulfilled.match(result)) {
            return payload as ProjectProcess
        } else {
            return rejectWithValue(payload ?? { kind: 'unknown' })
        }
    }
)

export const createCustomProcess = createAsyncThunk<ProjectProcessHeader, CreateCustomDocProcessPayload, AppThunkAPIType>(
    "documentation-processes/custom/create",
    async (createProcessPayload: CreateCustomDocProcessPayload, { rejectWithValue, dispatch }) => {
        const result = await dispatch(postWithAuth({
            url: "api/documentation-processes/custom",
            payload: createProcessPayload,
        }))
        const { payload } = result

        if (postWithAuth.fulfilled.match(result)) {
            return payload as ProjectProcessHeader
        } else {
            return rejectWithValue(payload ?? { kind: 'unknown' })
        }
    }
)


export interface CreateCustomDocumentPayload {
    documentType: DocumentTypes;
    structureId: string;
    processId: AppId | null;
    documentNumber: string;
    title: string;
    docDesignation: string;
    templateId: number;
    copyDocumentId: number;
    language: DocumentLanguages;
    creationMode: DocumentCreationModes;
}

export const createCustomDocument = createAsyncThunk<DocumentHeader, CreateCustomDocumentPayload, AppThunkAPIType>(
    "custom-document/create",
    async (data: CreateCustomDocumentPayload, { rejectWithValue, dispatch }) => {
        const result = await dispatch(postWithAuth({
            url: "api/document",
            payload: data,
        }))
        const { payload } = result

        if (postWithAuth.fulfilled.match(result)) {
            return payload as DocumentHeader
        } else {
            return rejectWithValue(payload ?? { kind: 'unknown' })
        }
    }
)
